module.exports = __webpack_public_path__ + "img/123456.c3f7917b.png";